export default __webpack_public_path__ + "static/media/MMCP_LOGO.179bde52.png";